import CylinderDetails from './cylinder_details';

export default CylinderDetails;
